import React from 'react';
import Hero from './components/Hero';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Media from './components/Media';
import AnimatedSection from './components/AnimatedSection';
import ContactForm from './components/ContactForm'; // DODAJ OVAJ IMPORT
import { education, achievements, testimonials, personalData } from './data/portfolioData';
import { FaGraduationCap, FaTrophy, FaQuoteLeft, FaHeart, FaCode } from 'react-icons/fa';
import Achievements from './components/Achievements';
import Education from './components/Education';
import Experience from './components/Experience';
import ProductLauncher from './components/ProductLauncher';
import LanguageSwitcher from './components/LanguageSwitcher';
import WebServicesPage from './components/WebServicesPage';
import WebPricingPreview from './components/WebPricingPreview';
import { useTranslation } from 'react-i18next';
import BeyondTheCode from './components/BeyondTheCode';
function App() {
  const { t } = useTranslation();
  if (window.location.pathname.replace(/\/$/,'') === '/izrada-sajtova') return <WebServicesPage />;
  return (
    
    <div className="bg-dark">
      <LanguageSwitcher />
      <ProductLauncher />
      <Hero />
      <WebPricingPreview />
      
      {/* Education & Achievements */}
      <section className="py-16 md:py-32">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            <Education />

            <Achievements />
          </div>
        </div>
      </section>

      <Skills />
      <Projects />
    <Experience />
    <BeyondTheCode />
      {/* 
     <section className="py-16 md:py-32">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <AnimatedSection>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4">
              What People <span className="text-gradient">Say</span>
            </h2>
            <p className="text-gray-400 text-center max-w-2xl mx-auto mb-8 md:mb-12 text-sm md:text-base px-4">
              Feedback from amazing people I've worked with
            </p>
          </AnimatedSection>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
            {testimonials.map((testimonial, index) => (
              <AnimatedSection key={index}>
                <div className="glass-effect rounded-xl md:rounded-2xl p-6 md:p-8 relative hover-glow transition-all">
                  <FaQuoteLeft className="text-primary/20 text-3xl md:text-4xl absolute top-4 right-4" />
                  <div className="flex items-center gap-3 md:gap-4 mb-4">
                    <div className="text-3xl md:text-4xl">{testimonial.avatar}</div>
                    <div>
                      <h3 className="font-bold text-base md:text-lg">{testimonial.name}</h3>
                      <p className="text-gray-400 text-xs md:text-sm">{testimonial.role}</p>
                    </div>
                  </div>
                  <p className="text-gray-300 italic leading-relaxed text-sm md:text-base">"{testimonial.content}"</p>
                  <div className="flex gap-1 mt-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <span key={i} className="text-yellow-500 text-sm md:text-base">★</span>
                    ))}
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>
    Testimonials */}
      {/* MEDIA & INTERVIEWS SEKSIJA */}
      <Media />

      {/* Contact Section - NOVI DIO SA EMAILJS */}
      <section id="contact" className="py-16 md:py-32 relative">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <AnimatedSection>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4">
              {t('contact.title')}
            </h2>
            <p className="text-gray-400 text-center max-w-2xl mx-auto mb-8 md:mb-12 text-sm md:text-base px-4">
              {t('contact.subtitle')}
            </p>
          </AnimatedSection>

          <div className="max-w-2xl mx-auto">
            {/* EmailJS kontakt forma */}
            <ContactForm />
            
            <div className="mt-6 md:mt-8 text-center text-gray-400 text-sm md:text-base">
              <p>{t('contact.direct')}:</p>
              <a href="mailto:dejanstanojevic461@gmail.com" className="text-primary hover:text-secondary transition break-all">
                dejanstanojevic461@gmail.com
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer sa potpisom */}
      <footer className="py-8 md:py-12 border-t border-white/10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-center text-center">
            <AnimatedSection>
              <div className="mb-6 md:mb-8">
                <img
                  src="/images/potpis1.png"
                  alt="Dejan Stanojević - Digital Signature"
                  className="h-12 md:h-16 lg:h-20 w-auto opacity-80 hover:opacity-100 transition-opacity duration-300"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <div className="hidden text-2xl md:text-3xl font-handwriting text-gray-400">
                  Dejan Stanojević
                </div>
              </div>
            </AnimatedSection>

            <p className="text-gray-400 text-xs md:text-sm mb-2">
              © 2026 Dejan Stanojević. {t('footer.rights')}.
            </p>
            <p className="text-gray-500 text-xs">
              {t('footer.student')}
            </p>
            
            <div className="mt-4 md:mt-6 text-gray-600 text-xs">
              <FaCode className="inline mr-1" /> {t('footer.built')}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;